import { API_BASE, parseResponse } from './api';

export async function fetchReports(page = 1, per = 50, search = '') {
  const params = new URLSearchParams({
    page: String(page),
    per: String(per),
    ...(search && { search })
  });
  const response = await fetch(`${API_BASE}/reports?${params.toString()}`);
  return parseResponse(response);
}

export async function fetchReportRecords(reportId, page = 1, per = 50) {
  const params = new URLSearchParams({
    page: String(page),
    per: String(per)
  });
  const response = await fetch(`${API_BASE}/reports/${encodeURIComponent(reportId)}/records?${params.toString()}`);
  return parseResponse(response);
}

export function getReportDownloadUrl(reportId) {
  return `${API_BASE}/reports/${encodeURIComponent(reportId)}/download`;
}

export async function uploadReport(formData) {
  const response = await fetch(`${API_BASE}/upload`, {
    body: formData,
    method: 'POST'
  });

  return parseResponse(response);
}

export async function deleteReport(reportId) {
  const response = await fetch(`${API_BASE}/reports/${encodeURIComponent(reportId)}`, {
    method: 'DELETE'
  });

  return parseResponse(response);
}

export async function bulkDeleteReports(reportIds) {
  const response = await fetch(`${API_BASE}/reports/bulk-delete`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ ids: reportIds })
  });

  return parseResponse(response);
}
